import { categoryMeta, roomMeta } from "../../js/theHub";

function hashHue(value) {
  let n = 0;
  String(value || "").split("").forEach((ch) => {
    n = (n * 31 + ch.charCodeAt(0)) % 360;
  });
  return n;
}

export default function RoomMark({ roomId, label, initials, tone, src, size = 64 }) {
  const meta = roomMeta(roomId) || categoryMeta(roomId);
  const wash = tone?.wash || meta?.tone?.wash || `hsl(${hashHue(label || roomId)} 18% 90%)`;
  const ink = tone?.ink || meta?.tone?.ink || "#2c2c2c";
  const accent = tone?.accent || meta?.tone?.accent || "#5a6a5a";
  const letters = initials || meta?.initials || String(label || roomId || "H").slice(0, 2).toUpperCase();

  if (src) {
    return (
      <span className="hub-mark hub-mark--photo" style={{ width: size, height: size }}>
        <img src={src} alt="" />
      </span>
    );
  }

  return (
    <span className="hub-mark" style={{ width: size, height: size, background: wash, color: ink }} aria-hidden="true">
      <svg viewBox="0 0 64 64" width={size} height={size}>
        <rect x="10" y="8" width="44" height="48" rx="4" fill="none" stroke={accent} strokeWidth="1.6" />
        <rect x="16" y="14" width="16" height="12" rx="1.5" fill={accent} opacity="0.22" />
        <rect x="36" y="14" width="12" height="12" rx="1.5" fill={accent} opacity="0.14" />
        <path d="M22 56 V36 h20 v20" fill="none" stroke={accent} strokeWidth="1.5" />
        <circle cx="38" cy="46" r="1.3" fill={accent} />
      </svg>
      <em>{letters}</em>
    </span>
  );
}
